import Auth0Configuration from './Auth0Configuration';

export default Auth0Configuration;
